import api from "../../api/api"

const state = {
  circleCreateCoin: 0 // 创建圈子所获邀币
  ,trendOutCoin: 0 // 发布动态所获邀币
  ,UserPoints:{} //积分相关信息汇总--今日已赚 所有积分 作品浏览量
  ,UserPointsHistory:{} //积分纪录列表
  ,getPointsMission:{} //积分任务
}

const getters = {

}

const mutations = {
    circleCreateCoin(state, res) {
        state.circleCreateCoin = res
    },
    trendOutCoin(state, res) {
        state.trendOutCoin = res
    }
    ,UserPointsIs(state, res) {
        state.UserPoints = res.data
    }
    ,UserPointsHistoryIs(state, res){
        state.UserPointsHistory = res.data
    }
    ,getPointsMissionIs(state, res){
        state.getPointsMission = res.data
    }
}

const actions = {
    getUserPoints(context, payload){
        return new Promise((resolve, reject)=>{
            api.UserPoints.getUserPoints(payload).then(res => {
                context.commit('UserPointsIs',res);
                resolve(res);
            }).catch(res => {
                reject(res);
            })
        })
    }
    ,getUserPointsHistory(context, payload){
        return new Promise((resolve, reject)=>{
            api.UserPoints.getUserPointsHistory().then(res => {
                context.commit('UserPointsHistoryIs',res);
                resolve(res);
            }).catch(res => {
                reject(res);
            })
        })
    }
    ,getPointsMission(context, payload){
        return new Promise((resolve, reject)=>{
            api.UserPoints.getPointsMission().then(res => {
                context.commit('getPointsMissionIs',res);
                resolve(res);
            }).catch(res => {
                reject(res);
            })
        })
    }

}

export default {
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/vuex/modules/coin.js